/**
 * API may return participation rows under `requests` even when `status` is approved / in progress.
 * Your Jobs = active work; Requests = still awaiting a decision (pending) or rejected.
 */

export function participationStatus(raw: unknown): string {
    if (!raw || typeof raw !== 'object') return '';
    return String((raw as Record<string, unknown>).status ?? '').toLowerCase();
}

export function isBuzzBridgeJobLikeParticipation(raw: unknown): boolean {
    const s = participationStatus(raw);
    return s === 'approved' || s === 'in_progress' || s === 'completed';
}

/** Rows that belong in the Requests tab (not yet an active job). */
export function filterRequestsTabRows(rows: unknown[] | undefined): unknown[] {
    if (!rows?.length) return [];
    return rows.filter(r => !isBuzzBridgeJobLikeParticipation(r));
}

/**
 * Merge `active_jobs` with request rows that are already approved / in progress / completed.
 * Dedupes by participation `_id`.
 */
export function buildJobsTabRows(activeJobs: unknown[] | undefined, requests: unknown[] | undefined): unknown[] {
    const jobs = [...(activeJobs ?? [])];
    const fromRequests = (requests ?? []).filter(isBuzzBridgeJobLikeParticipation);
    const seen = new Set<string>();
    for (const j of jobs) {
        if (j && typeof j === 'object' && '_id' in j) seen.add(String((j as { _id: string })._id));
    }
    const out = [...jobs];
    for (const r of fromRequests) {
        const id = r && typeof r === 'object' && '_id' in r ? String((r as { _id: string })._id) : '';
        if (id && !seen.has(id)) {
            seen.add(id);
            out.push(r);
        }
    }
    return out;
}
